import { TourConfig, startTour, CONTINUE_PLATFORM_TOUR_BUTTON } from './TourSystem';
import PageWelcomeModal from './PageWelcomeModal';
import 'driver.js/dist/driver.css';

const financialTourConfig: TourConfig = {
    tourId: 'financial',
    steps: [
        {
            element: '#financial-title',
            popover: {
                title: '🏦 My Vault',
                description: 'Welcome to your secure financial headquarters. Here you can manage your earnings, process global payments, and hold assets in multiple currencies.',
                side: "bottom",
            }
        },
        {
            element: '#financial-wallets',
            popover: {
                title: '💳 Global Wallets',
                description: 'This section displays all your active wallets. You can hold balances in USD, EUR, GBP, and even Crypto. Click "+ New Wallet" to instantly open a new currency account.',
                side: "bottom",
            }
        },
        {
            element: '#financial-actions',
            popover: {
                title: '⚡ Quick Actions',
                description: 'Your financial command center. From here, you can execute any transaction instantly.',
                side: "left",
            }
        },
        {
            element: '#financial-send',
            popover: {
                title: '💸 Send Money',
                description: 'Transfer funds instantly to other TechUnity members or external accounts. Secure, fast, and low fee.',
                side: "left",
            }
        },
        {
            element: '#financial-request',
            popover: {
                title: '📥 Request Payment',
                description: 'Need to get paid? Send a formal payment request to any client email. They will receive a secure link to pay you immediately.',
                side: "left",
            }
        },
        {
            element: '#financial-deposit',
            popover: {
                title: '➕ Add Funds',
                description: 'Top up your wallet using Credit Card, Mobile Money (MFS Africa), Bank Wire, or Crypto (NowPayments).',
                side: "left",
            }
        },
        {
            element: '#financial-invoice',
            popover: {
                title: '📄 Create Invoice',
                description: 'Generate professional, itemized invoices for your freelance work. Track status and get paid directly into your Vault.',
                side: "left",
            }
        },
        {
            element: '#financial-escrow',
            popover: {
                title: '🔒 Secure Escrow',
                description: 'Working on a big project? Create an Escrow contract. Funds are locked securely and only released when milestones are met, protecting both you and the client.',
                side: "left",
            }
        },
        {
            element: '#financial-withdraw',
            popover: {
                title: '🏦 Withdraw Funds',
                description: 'Ready to cash out? Withdraw your earnings to your local Bank Account, Mobile Money wallet, or Payoneer account.',
                side: "left",
            }
        },
        {
            element: '#financial-kyc',
            popover: {
                title: '🛡️ Identity Verification',
                description: 'Unlock higher transaction limits by verifying your identity. Upload your ID or Passport here to reach VIP Tier status.',
                side: "left",
            }
        },
        {
            element: '#financial-history',
            popover: {
                title: '📜 Transaction Ledger',
                description: `A complete, immutable record of every transaction. Track incoming payments, outgoing transfers, and escrow releases in real-time.${CONTINUE_PLATFORM_TOUR_BUTTON}`,
                side: "top",
            }
        }
    ],
};

export const startFinancialTour = () => {
    startTour(financialTourConfig);
};

const FinancialTour = () => {
    return (
        <PageWelcomeModal
            title="Welcome to My Vault"
            description="Let us show you how to manage your global finances securely."
            onStartTour={startFinancialTour}
            tourId="financial"
        />
    );
};

export default FinancialTour;
